import { ChangeDetectionStrategy, Component, EventEmitter, inject, Output } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'
import { PrimeTemplate } from 'primeng/api'
import { Button } from 'primeng/button'
import { Dialog } from 'primeng/dialog'

import { Action, Resource, Role } from '@ti/contracts'
import { AppCommonModule } from '@ti/core/common/common.module'

import { BaseRoleEditModel, RoleFormMode } from '../../models'
import { RoleFormComponent } from '../form/role-form.component'

@Component({
  selector: 'app-edit-role-dialog',
  templateUrl: 'edit-role-dialog.component.html',
  styleUrls: ['edit-role-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Dialog, TranslatePipe, RoleFormComponent, Button, AppCommonModule, PrimeTemplate],
})
export class EditRoleDialogComponent {
  @Output() readonly duplicateClicked = new EventEmitter<Role>()
  protected readonly editModel = inject(BaseRoleEditModel)
  protected readonly TYPES = { Action, Resource, RoleFormMode }
}
